import React, { useMemo } from 'react';
import styled from 'styled-components';
import { panelTheme } from '../../PanelComerciales.theme';

const HeaderRoot = styled.header`
    background: ${panelTheme.colors.surface};
    border-bottom: 1px solid ${panelTheme.colors.border};
    padding: 12px 24px;
    position: sticky;
    top: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    gap: 16px;
    border-top-left-radius: ${panelTheme.radius.md};
    border-top-right-radius: ${panelTheme.radius.md};

    .brand {
        display: flex;
        flex-direction: column;
        line-height: 1.1;

        strong {
            font-size: 14px;
            color: ${panelTheme.colors.text};
        }
        span {
            font-size: 11px;
            color: ${panelTheme.colors.textMuted};
        }
    }
`;

const StickyHeader: React.FC = () => {
    const today = useMemo(
        () =>
            new Date().toLocaleDateString('es-MX', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            }),
        [],
    );

    return (
        <HeaderRoot>
            <div className='brand'>
                <strong>Panel de Controles Comerciales</strong>
                <span>{today}</span>
            </div>
        </HeaderRoot>
    );
};

export default StickyHeader;
